import ProductState from '../interfaces/state';

const productInitialState: ProductState = {
  items: null,
};

export default productInitialState;
